export const Theme = {
  typography: {
    fontFamily: ["DMSans-Regular"],
  },
  palette: {
    primary: {
      main: "#008938",
    },
    secondary: {
      main: "#db1102",
    },
    light: {
      main: "white",
    },
  },
  overrides: {
    MuiButton: {
      root: {
        color: "#008938",
      },
      containedPrimary: {
        color: "#008938",
      },
      outlinedPrimary: {
        color: "#008938",
        border: "#008938",
      },
      text: {
        color: "#008938",
      },
    },
    MuiListItemIcon: {
      root: {
        minWidth: 30,
      },
    },
    MuiTypography: {
      colorTextSecondary: {
        color: "#fff",
      },
    },
  },
};
export const unprotected_route_theme = {
  typography: {
    fontFamily: ["DMSans-Regular"],
  },
  palette: {
    primary: {
      main: "#008a52",
    },
  },
  overrides: {
    MuiButton: {
      root: {
        borderRadius: 0,
      },
      containedPrimary: {
        color: "#fff",
      },
      text: {
        color: "#008a52",
      },
    },
    MuiListItemIcon: {
      root: {
        minWidth: 30,
      },
    },
    MuiTypography: {
      colorTextSecondary: {
        color: "#fff",
      },
    },
  },
};
